module.exports = __webpack_public_path__ + "/img/6d335e489202c31161cb3f87c6be3ed9.png";